import { AnyAction } from "redux";
import {
  LOGOUT_SUCCESS,
} from "../../common/redux/actions";
import { AAD_ACCOUNT_ADDED, AAD_LOGIN_SUCCESS, ACQUIRED_TOKEN } from "./actions";
import { AuthState } from "../../common/redux/AuthState";

export const reducer = (
  state: AuthState = {
    user: null,
    loginStatus: "LOGGING_IN",
  },
  action: AnyAction
) => {
  const { type, payload } = action;
  switch (type) {
    case AAD_LOGIN_SUCCESS:
    case AAD_ACCOUNT_ADDED:
      const upn: string = payload.account.username;
      const user = {
        upn,
        displayName: payload.account.name,
        token: payload.idToken
      };
      return { ...state, user, loginStatus: "LOGGED_IN" };
    case LOGOUT_SUCCESS:
      return { ...state, user: null, loginStatus: "LOGGED_OUT" };
    case ACQUIRED_TOKEN:
      const tokenUser = {
        upn: payload.account.username,
        displayName: payload.account.name,
        token: payload.token,
      };
      return { ...state, user: { ...state.user, ...tokenUser } };
    default:
      return state;
  }
};
